export default "__VITE_ASSET__a427d522__"